var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Dialog from 'quasar/src/plugins/Dialog.js';;
export default function (cellProps, ctx, e) {
    Dialog.create({
        title: 'Confirm',
        message: 'Please confirm user deletion',
        cancel: true,
        persistent: true
    }).onOk(() => __awaiter(this, void 0, void 0, function* () {
        ctx.$store.dispatch('users.users/delete', { id: cellProps.row.id });
    })).onCancel(() => {
        // console.log('>>>> Cancel')
    }).onDismiss(() => {
        // console.log('I am triggered on both OK and Cancel')
    });
}
